document.addEventListener('DOMContentLoaded', function () {
    const expandButton = document.querySelector('[data-expand-toggle]');
    if (expandButton) {
        expandButton.addEventListener('click', function () {
            const target = document.querySelector(this.dataset.target);
            const label = this.querySelector('.button__label');

            if (!target) {
                console.error('Target element not found');
                return;
            }

            // Toggle Expanded State
            target.classList.toggle('collection-list__collections--expanded');

            const isExpanded = target.classList.contains('collection-list__collections--expanded');

            // Update button text
            label.textContent = isExpanded ?
                label.dataset.expandedText :
                label.dataset.collapsedText;

            // Updating the container's data-expanded property
            const container = document.querySelector('.collection-list__inner');
            if (container) {
                container.setAttribute('data-expanded', isExpanded);
            }
        });
    }
});